import { render, staticRenderFns } from "./OtherLoanFormStatusModal.vue?vue&type=template&id=1756b790"
import script from "./OtherLoanFormStatusModal.vue?vue&type=script&lang=js"
export * from "./OtherLoanFormStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports